// Validate form on language "es"
export const dict = {
  es: {
    custom: {
      name: {
        required: () => 'Nombre o Razón social es obligatorio.',
        min: (name, value) => 'Nombre o Razón debe tener al menos ' + value + ' caracteres.'
      },
      lastname: {
        required: () => 'Apellido es obligatorio',
        alpha_spaces: () => 'Apellido Paterno solo permite letras y espacios.',
        min: (name, value) => 'Apellido Paterno debe tener al menos ' + value + ' caracteres.'
      },
      lastname2: {
        alpha_spaces: () => 'Apellido Paterno solo permite letras y espacios.',
        min: (name, value) => 'Apellido Paterno debe tener al menos ' + value + ' caracteres.'
      },
      phone: {
        required: () => 'Telefono es obligatorio.',
        numeric: () => 'Telefono solo permite números.',
        min: (name, value) => 'Telefono debe tener al menos ' + value + ' números.',
        max: (name, value) => 'Telefono debe tener como máximo ' + value + ' números.'
      },
      password: {
        required: () => 'Contraseña es obligatorio.',
        min: (name, value) => 'Contraseña debe tener al menos ' + value + ' caracteres.'
      },
      password_confirmation: {
        required: () => 'Confirmar contraseña es obligatorio.',
        min: (name, value) => 'Confirmar contraseña debe tener al menos ' + value + ' caracteres.'
      },
      name_patient_type: {
        required: () => 'Nombre es obligatorio'
      },
      parent_id: {
        required: () => 'Tipo Padre es obligatorio'
      },
      description: {
        required: () => 'Descripción es obligatorio'
      },
      rut: {
        required: () => 'Rut es requerido'
      },
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/lang/es/dict.js